import React from 'react';
import {
  Create, SimpleForm, TextInput, NumberInput, ReferenceInput, SelectInput
} from 'react-admin';

const redirect = (basePath, id, data) => `/windTurbineWebpages`;
const transform = (data) => {
  if (data.windTurbine) {
    data.windTurbineId = data.windTurbine.id;
  }

  return data;
}

export default (props) => (
  <Create title="Create a new webpage link" {...props} transform={transform}>
    <SimpleForm redirect={redirect}>
      <ReferenceInput label="Wind Turbine" source="windTurbine.id" reference="windTurbines" perPage={1000}>
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput source="label" helperText="Ce se vede pe buton, ex. 'PLC HMI'" />
      <TextInput
        source="url"
        label="URL"
        fullWidth
        helperText="Adresa completă (ex. http://192.168.100.177) - trebuie să fie accesibilă din rețeaua celui care apasă link-ul (VPN/on-site) până se implementează tunelul."
      />
      <NumberInput source="sortOrder" label="Order" defaultValue={0} helperText="Ordinea de afișare (mai mic = mai sus)" />
    </SimpleForm>
  </Create>
);
